import { gsap, ScrollTrigger } from "./globals.js";
document.addEventListener("DOMContentLoaded", () => {
	// IMAGE MARQUEE
	const marqueeWrap = document.querySelector(".image-marquee");
	if (marqueeWrap) {
		gsap.registerPlugin(ScrollTrigger);

		gsap.to(".image-marquee__row--top", {
			xPercent: -30,
			ease: "none",
			scrollTrigger: {
				trigger: marqueeWrap,
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
			}
		});

		gsap.to(".image-marquee__row--bottom", {
			xPercent: 30,
			ease: "none",
			scrollTrigger: {
				trigger: marqueeWrap,
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
			}
		});
	}
});
